import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from "@angular/core";
import { QuotesServiceProvider, RouteDataProvider, AlertService, RequestHelperProvider, ItemServiceProvider, StorageServiceProvider, DialogCloseService, GatewayServiceProvider, CryptoService } from "../../_services/services";
import { Global } from 'src/app/globals';
import Utils from 'src/app/utils';
import * as Sentry from '@sentry/angular';
import { PendingAgreementConfig } from 'src/app/_models/booking/pending-agreement-config';
import { AppSettingsServiceProvider } from '../../_services/app-settings.service';
import { ItemRequest } from "src/app/_models/item/item-request.model";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Title } from "@angular/platform-browser";
import { ServiceLocator } from "src/app/locater.service";
import { BookingServiceProvider } from "src/app/_services/booking.service";
import { Router } from "@angular/router";
import { MaterialModule } from "src/app/material.module";
import { SharedModule } from "src/app/shared.module";
import { LoadingService } from "src/app/_services/loading.service";


interface Filter {
    value: number;
    viewValue: string;
}

@Component({
    templateUrl: './history.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule,

    ]
})
export class historyComponent {
    panelOpenState = false;
    quoteSearch: String = "";
    quotes: any = [];
    BookingData: any = [];
    newBookingData: any = [];
    selectedItems: any = [];
    
    // Pagination
    pageSize = 50;
    currentPage = 1;
    hasMorePages = false;
    isLoading = false;
    
    QuoteButtonName: string = "Quote";
    BookingButtonName: string = "Book";
    PrepayButtonName: string = "Prepay"
    HideBookingButton: boolean = false;
    HidePrepayButton: boolean = false;
    loading = false;
    productQuantityPrecision: number;
    unitPricePrecision: number;
    FilerValue: Filter[] = [
        { value: 0, viewValue: 'Show All' },
        { value: 1, viewValue: 'Pending ' },
        { value: 2, viewValue: 'Approved' },
        { value: 3, viewValue: 'Quote' },
        { value: 4, viewValue: 'Booking' },
        { value: 5, viewValue: 'Prepay' },
        { value: 6, viewValue: 'Order' },
    ];
    FilterSelectedvalue: number = 0;

    public pendingAgreementConfig: PendingAgreementConfig = {
        pendingAgreementStatus: false,
        emailType: "",
        pendingBookingStatus: "",
        pendingBookingStatusDescription: "",
        pendingPrepayStatus: "",
        pendingPrepayStatusDescription: "",
        pendingOrderStatus: "",
        pendingOrderStatusDescription: "",
        pendingQuoteStatus: "",
        pendingQuoteStatusDescription: "",
        PendingSignatureRequiredStatus: false,
        ButtonQuote: "Quote",
        ButtonBooking: "Book",
        ButtonPrepay: "Prepay",
        SameBookingNumberConfig: false,

    };

    constructor(public globals: Global,
        public cryptoService: CryptoService,
        private itemServiceProvider: ItemServiceProvider,
        private gatewayService: GatewayServiceProvider,
        public quotesService: QuotesServiceProvider,
        public bookingService: BookingServiceProvider,
        private dataProvider: RouteDataProvider,
        private router: Router,
        private alertService: AlertService,
        private requestHelper: RequestHelperProvider,
        public dialog: MatDialog,
        public titleService: Title,
        private blockUI: LoadingService
    ) {
        this.getData(0);

    }
    getData(FilerValue: number) {
        this.currentPage = 1;
        this.BookingData = [];
        this.newBookingData = [];
        this.loadBookings(FilerValue);
    }

    private loadBookings(FilerValue: number) {
        this.requestHelper.refreshAgrisLicenseCounter().then(async () => {
            this.blockUI.start();
            this.isLoading = true;
            
            try {
                // FilerValue 1 = Pending only, 2 = Approved only, all others = both
                const fetchPending = FilerValue !== 2;
                const fetchApproved = FilerValue !== 1;

                const [pendingData, approvedData] = await Promise.all([
                    fetchPending ? this.bookingService.getPendingBooking(FilerValue, this.currentPage, this.pageSize, 'BookingId', 'DESC') : Promise.resolve(null),
                    fetchApproved ? this.bookingService.getApprovedBooking(FilerValue, this.currentPage, this.pageSize, 'BookingId', 'DESC') : Promise.resolve(null)
                ]);

                // Extract items from TransactionObject - API returns { Items: [], PageNumber, etc }
                const pendingBookings = Array.isArray(pendingData?.TransactionObject?.Items) ? pendingData.TransactionObject.Items : [];
                const approvedBookings = Array.isArray(approvedData?.TransactionObject?.Items) ? approvedData.TransactionObject.Items : [];
                
                if (this.currentPage === 1) {
                    this.BookingData = [...pendingBookings, ...approvedBookings];
                } else {
                    this.BookingData = [...this.BookingData, ...pendingBookings, ...approvedBookings];
                }
                
                // Check if more pages available from either dataset
                const pendingHasMore = pendingData?.TransactionObject?.HasNextPage || false;
                const approvedHasMore = approvedData?.TransactionObject?.HasNextPage || false;
                this.hasMorePages = pendingHasMore || approvedHasMore;
                this.newBookingData = this.BookingData;
                
            } catch (error) {
                console.log(error);
                this.alertService.error(error.Message || 'Error loading bookings');
            } finally {
                this.isLoading = false;
                this.blockUI.stop();
            }
        }).catch((err) => {
            console.log(err);
            this.blockUI.stop();
        });
    }

    @HostListener('document:scroll')
    public onViewportScroll(_event?: Event) {
        const scrollPosition = window.scrollY + window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        
        // Load more when 500px from bottom
        if (documentHeight - scrollPosition < 500 && this.hasMorePages && !this.isLoading) {
            this.currentPage++;
            this.loadBookings(this.FilterSelectedvalue);
        }
    }

    async getItems(BookingData) {
        this.blockUI.start();
        this.selectedItems = [];
        try {
            BookingData.items = await this.ensureBookingItems(BookingData);
            BookingData.CalTotalPrice = 0;
        } catch (error) {
            Sentry.captureMessage("Handled Error" + JSON.stringify(error));
            console.log(error);
            this.alertService.error(error.Message);
        } finally {
            this.blockUI.stop();
        }
    }

    isCopySupported(bookingData: any): boolean {
        return this.getCopyRouteType(bookingData) !== null;
    }

    getCopyButtonLabel(bookingData: any): string {
        return this.getCopyRouteType(bookingData) === 'order' ? 'Copy Order' : 'Copy';
    }

    async startCopyOrder(bookingData: any) {
        const copyType = this.getCopyRouteType(bookingData);
        if (!copyType) {
            this.alertService.warning('Copy Order is only available for Booking, Prepay, and Order history records.', false, true);
            return;
        }

        const customerId = this.getHistoryCustomerId(bookingData);
        if (!customerId) {
            this.alertService.error('Unable to copy this record because the customer could not be identified.');
            return;
        }

        this.blockUI.start();
        let destinationOwnsLoader = false;
        try {
            const items = await this.ensureBookingItems(bookingData);
            if (!items || items.length === 0) {
                this.alertService.warning('Unable to copy this record because no item details were found.', false, true);
                return;
            }

            this.dataProvider.storage = {
                history: {
                    ...bookingData,
                    CustomerId: customerId,
                },
                items: JSON.parse(JSON.stringify(items)),
                type: copyType,
            };

            if (copyType === 'order') {
                destinationOwnsLoader = await this.router.navigate(['order', { from: 'historycopy' }]);
            } else {
                destinationOwnsLoader = await this.router.navigate(['booking', { from: 'historycopy', type: copyType }]);
            }
        } catch (error) {
            Sentry.captureMessage("Handled Error" + JSON.stringify(error));
            console.log(error);
            this.alertService.error(error.Message);
        } finally {
            if (!destinationOwnsLoader) {
                this.blockUI.stop();
            }
        }
    }

    private ensureBookingItems(bookingData: any): Promise<any[]> {
        if (bookingData.items && bookingData.items.length > 0) {
            return Promise.resolve(bookingData.items);
        }

        return this.quotesService.getItems(bookingData.BookingId, bookingData.Location).then((items) => {
            bookingData.items = items.TransactionObject || [];
            return bookingData.items;
        });
    }

    private getCopyRouteType(bookingData: any): 'book' | 'prepay' | 'order' | null {
        const transactionType = (bookingData?.TransactionType || '').toString().toLowerCase();

        if (transactionType.includes('order')) {
            return 'order';
        }

        if (transactionType.includes('prepay')) {
            return 'prepay';
        }

        if (transactionType.includes('book')) {
            return 'book';
        }

        return null;
    }

    private getHistoryCustomerId(bookingData: any): string {
        return bookingData?.CustomerId
            || bookingData?.CustomerID
            || bookingData?.NameId
            || bookingData?.ClientId
            || bookingData?.customerId
            || '';
    }

    showDialog(selectedItem, item, positiveKey, restrictedData) {
        this.blockUI.start();
        let signatureImage = "";
        this.itemServiceProvider.getSignatureById(selectedItem.BookingId).then((signature) => {
            if (signature.length === 0) {

            } else {
                signatureImage = "data:image/png;base64," + signature;

                const dialogRef = this.dialog.open(ViewDetailDialog, {
                    width: '2000px',
                    data: { message: signatureImage, item: item, selectedItem: selectedItem, positiveKey: positiveKey, restrictedData: restrictedData },
                });
                this.blockUI.stop();
                dialogRef.afterClosed().subscribe(() => {

                });
            }

        });


    }


    filterQuote(BookingData: any): any {
        if (this.BookingData && this.BookingData.length > 0 && this.quoteSearch && this.quoteSearch.length >= 3) {
            return this.BookingData.filter(q => q.CustomerDescription.toLowerCase().includes(this.quoteSearch.toLowerCase()));
        }
        return this.newBookingData;
    }

    onFilterChange(selectedValue: any) {
        this.FilterSelectedvalue = selectedValue.value;
        this.getData(this.FilterSelectedvalue);
    }



    onClickPrintButton(BookingData: any, BookingItems: any) {

        this.blockUI.start();
        // this.gatewayService.printAndDownloadBooking(this.bookingReceiptNumber, this.isAutoApprove == false , (response: any) => {     
        //   if (response) {


        switch (BookingData.Status) {
            case 1: {
                if (BookingData.IsPendingFileFlob) {
                    this.downloadPdfFromUrl(BookingData);
                } else {
                    this.getPrintFromAgris(BookingData);
                };
                break;
            }
            case 2: {
                if (BookingData.IsApprovedFileFlob) {
                    this.downloadPdfFromUrl(BookingData);
                } else {
                    this.getPrintFromAgris(BookingData);
                };
                break;
            }


        }

    }
    private downloadPdfFromUrl(BookingData) {

        let bookingid = this.cryptoService.encryptString(String(BookingData.BookingId));
        let pdfLink = `${Utils.GetSalesReviewRemoteServer()}/BookingsV2/GetPrintForm?id=${bookingid}&isPending=${BookingData.Status == 2 ? false : true}`;
        console.log(pdfLink);

        //this.bookingService.getPdfFromURL(encodeURI,BookingData.BookingId).then((response) => { 
        this.bookingService.DownloadprintTransaction(Utils.GetSalesReviewRemoteServer(), BookingData.BookingId, BookingData.Status == 2 ? false : true, BookingData.BookingNumber).then((response) => {
            console.log(response);
            this.blockUI.stop();
        }).catch((error) => {
            // if (error.status == 404){
            //     try{
            //       let printResponse= this.getPrintFromAgris(BookingData);
            //     }catch(error){
            //         this.alertService.warning(error.message);  
            //     }
            // }
            console.log(error);
            this.blockUI.stop();

        });
    }

    private getPrintFromAgris(BookingData) {
        this.gatewayService.printBooking(BookingData.BookingId, BookingData.Status == 1 ? true : false, false, (response: any) => {
            if (response.TransactionObject) {
                console.log("in if block");
                this.downloadPdfFromUrl(BookingData);

            } else {
                this.alertService.warning("Agris Error :" + response.TransactionMessage);
                this.blockUI.stop();
            }

        }, (error: any) => {
            console.log(error);
            this.blockUI.stop();
            Sentry.captureMessage("Handled Error: " + JSON.stringify(error));

        });
    }

    public onScroll() {
        console.log("in scroll");
    }





}
export interface DialogData {
    message: string;
    item: any;
    selectedItem: any;
    positiveKey: string;
    unitPricePrecision: number;
    productQuantityPrecision: number;
    restrictedData: any;
}
@Component({
    selector: 'View-Detail-dialog',
    templateUrl: 'View-Detail-dialog.html',
    styleUrls: [
        "./View-Detail-dialog.scss"
    ],
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule,
    ]
})

export class ViewDetailDialog implements OnInit {
    rowHeight: any;
    displayedColumns: string[] = ['ProductId', 'Description', 'Quantity', 'Price'];
    dataSource = ELEMENT_DATA;
    constructor(
        public dialogRef: MatDialogRef<ViewDetailDialog>,
        private alertService: AlertService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private closeDialogService: DialogCloseService

    ) {

        dialogRef.disableClose = true;
        this.closeDialogService.emitRegisterDialog(dialogRef);
    }


    ngOnInit() {
        this.rowHeight = (window.innerWidth <= 400) ? '1 : 7' : '1: 2';
    }

    onResize(event: any) {
        this.rowHeight = (event.target.innerWidth <= 400) ? '1 : 7' : '1: 2';
    }
    @HostListener('window:keyup.esc') onKeyUp() {
        this.dialogRef.close();
    }
    onNoClick(): void {
        this.dialogRef.close();
    }
    onPositiveClick(): void {
        if (this.data.restrictedData.overrideRestricted) {
            if (this.data.selectedItem.Price < this.data.item.minimumPrice) {
                this.alertService.error("Current price is less than minimum price.", false, true);
                return;
            } else if (this.data.selectedItem.Price > this.data.item.maximumPrice) {
                this.alertService.error("Current price is greater than maximum price", false, true);
                return;
            }
            else {
                this.dialogRef.close(this.data.selectedItem);
            }
        }
        else {
            this.dialogRef.close(this.data.selectedItem);
        }
    }

}
export interface PeriodicElement {
    name: string;
    position: number;
    weight: number;
    symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
    { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
    { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
    { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
    { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
    { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
    { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
    { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
    { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
    { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
    { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];